import { z } from 'zod';
/** Identificador estable del servicio backend. */
export const SERVICE_NAME = 'tcg-server';
/** Versiones expuestas por el contrato: `major.minor.patch`. */
const SemVerCoreSchema = z
    .string()
    .regex(/^\d+\.\d+\.\d+$/u, 'Se espera una version con el formato `major.minor.patch`.');
/**
 * Contrato de la respuesta de `GET /health`.
 *
 * Es la unica fuente de verdad compartida: el servidor valida su payload
 * saliente contra este esquema y el cliente podra validar el entrante.
 */
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.literal(SERVICE_NAME),
    version: SemVerCoreSchema,
});
/**
 * Construye una respuesta de health ya validada.
 *
 * @throws {z.ZodError} Si `version` no respeta el contrato.
 */
export function createHealthResponse(version) {
    return HealthResponseSchema.parse({
        status: 'ok',
        service: SERVICE_NAME,
        version,
    });
}
//# sourceMappingURL=health.js.map